<template>

  <ion-card-header class="ion-text-center ion-no-padding">
    <p>MOUTIER <span style="color: red;">•</span> FORUM DE L'ARC <br>4 - 8 MARS 2026</p>
  </ion-card-header>

  <ion-card id="horaires" class="horaires-home-page">
    <ion-card-content class="ion-text-center no-padding-top">
      <ion-card-subtitle class="texte-horaire-titre">Heures d’ouverture :</ion-card-subtitle>
      <ion-grid class="texte-horaire">
        <ion-row >
          <ion-col>
            Mercredi, jeudi, vendredi: 8h - 18h
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            Samedi, dimanche: 10h00 – 17h00
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
</template>

<script>
import {
  IonCard,
  IonCardContent,
  IonCardHeader, IonCardSubtitle,
  IonCol,
  IonGrid,
  IonRow
} from "@ionic/vue";

export default {
  name: 'Horaires',
  components: {
    IonCard,
    IonCardContent,
    IonCardHeader,

    IonCardSubtitle,
    IonGrid,
    IonCol,
    IonRow
  }
}
</script>

<style scoped lang="sass">
#horaires
  margin-top: 5px
  /*background-image: url("~@/assets/photos/salon-hor.jpg");*/
  min-height: 350px
  background-size: cover
  background-position: center
  background-repeat: no-repeat
  /* background-attachment: fixed; *

  background-image: url("~@/assets/salon26_visuel.png")
  //background-image: url("~@/assets/salon24_visuel sans logo.jpg")
  // background-image: url("~@/assets/photos/fusee.png"), linear-gradient(to right,var(--ion-color-primary), var(--ion-color-secondary))
  background-blend-mode: multiply
  // background-image: url("~@/assets/photos/fusee.png")

    /* Titre des horaires en gras */
  .texte-horaire-titre
    font-weight: bold

  /* Lignes d’horaires normales */
  .texte-horaire
    font-weight: normal
    font-size: 1em
    padding: 2.5px
    color: #1a1a1a

  ion-card-header
      padding-bottom: 0

  ion-card-title,
  ion-card-subtitle
    color: var(--ion-color-success-contrast)
    text-shadow: 0 0 3px rgba(255, 255, 255, 0.3)

  ion-card-content
    padding-top: 20px
    font-weight: bold
    color: var(--ion-color-primary-contrast)
    text-shadow: 0 0 2px rgba(0, 0, 0, .3)
    // background: rgb(255,255,255)
    // background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.5) 30%)

  ion-card-content ion-row ion-col
    font-size: 1em
    padding: 2.5px
    color: #1a1a1a

  ion-card-content ion-row.notes ion-col
    padding-top: 0
    padding-left: 1em
    font-size: .8em



</style>
